import { IManageTreeItem } from "./tree.interface";

export interface IEntity {
  id: string;
  rootName?: string;
  parentId: string;
  email: string;
  name: string;
  phone: string;
  reference: string;
  state: State;
  country: number;
  totalUsers: number;
  activeUsers: number;
  levelInTree?: number;
  maxEntitiesLevel?: number;
}

export type AddEntity = {
  name: string;
  email?: string;
  phone?: string;
  reference?: string;
  state: State;
};

export type UpdateEntity = { id: string } & Partial<AddEntity>;

export interface IEntitiesTreeItem
  extends IEntity,
    IManageTreeItem<IEntitiesTreeItem> {
  // childNodes?: IEntitiesTreeItem[];
}

export enum State {
  AL = "Alabama",
  AK = "Alaska",
  AZ = "Arizona",
  AR = "Arkansas",
  CA = "California",
  CO = "Colorado",
  CT = "Connecticut",
  DE = "Delaware",
  FL = "Florida",
  GA = "Georgia",
  HI = "Hawaii",
  ID = "Idaho",
  IL = "Illinois",
  IN = "Indiana",
  IA = "Iowa",
  KS = "Kansas",
  KY = "Kentucky",
  LA = "Louisiana",
  ME = "Maine",
  MD = "Maryland",
  MA = "Massachusetts",
  MI = "Michigan",
  MN = "Minnesota",
  MS = "Mississippi",
  MO = "Missouri",
  MT = "Montana",
  NE = "Nebraska",
  NV = "Nevada",
  NH = "New Hampshire",
  NJ = "New Jersey",
  NM = "New Mexico",
  NY = "New York",
  NC = "North Carolina",
  ND = "North Dakota",
  OH = "Ohio",
  OK = "Oklahoma",
  OR = "Oregon",
  PA = "Pennsylvania",
  RI = "Rhode Island",
  SC = "South Carolina",
  SD = "South Dakota",
  TN = "Tennessee",
  TX = "Texas",
  UT = "Utah",
  VT = "Vermont",
  VA = "Virginia",
  WA = "Washington",
  WV = "West Virginia",
  WI = "Wisconsin",
  WY = "Wyoming",
  DC = "District of Columbia",
  AS = "American Samoa",
  GU = "Guam",
  MP = "Northern Mariana Islands",
  PR = "Puerto Rico",
  UM = "United States Minor Outlying Islands",
  VI = "Virgin Islands, U.S.",
}
